<template>
  <div>
    <header>
      <h3 class="float-left">廣告總覽報表</h3>
    </header>
    <v-container>
      <v-row align="center">
        <v-col cols="12" sm="4">
          <v-select
            v-model="days"
            :items="dayOptions"
            label="統計期間"
            outlined
            dense
            hide-details
            @change="load"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="8" class="text-sm-right">
          <v-btn color="primary" to="/dashboard/ads">回廣告列表</v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="4">
          <div class="metric">
            <div class="metric-label">總曝光</div>
            <div class="metric-value">
              {{ report.totals.impressions.toLocaleString() }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="metric">
            <div class="metric-label">總點擊</div>
            <div class="metric-value">
              {{ report.totals.clicks.toLocaleString() }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="metric">
            <div class="metric-label">平均 CTR</div>
            <div class="metric-value">{{ formatCTR(report.totals.ctr) }}</div>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>版位比較</v-card-title>
            <v-data-table
              dense
              :headers="slotHeaders"
              :items="report.bySlot"
              :loading="loading"
              hide-default-footer
            >
              <template v-slot:item.slot="{ item }">
                {{ slotText(item.slot) }}
              </template>
              <template v-slot:item.ctr="{ item }">
                {{ formatCTR(item.ctr) }}
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>每日趨勢</v-card-title>
            <v-data-table
              dense
              :headers="dateHeaders"
              :items="report.byDate"
              :loading="loading"
              :items-per-page="7"
            >
              <template v-slot:item.ctr="{ item }">
                {{ formatCTR(item.ctr) }}
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>點擊最高</v-card-title>
            <v-data-table
              dense
              :headers="adHeaders"
              :items="report.topClicks"
              :loading="loading"
            >
              <template v-slot:item.slot="{ item }">
                {{ slotText(item.slot) }}
              </template>
              <template v-slot:item.ctr="{ item }">
                {{ formatCTR(item.ctr) }}
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>CTR 最高</v-card-title>
            <v-data-table
              dense
              :headers="adHeaders"
              :items="report.topCTR"
              :loading="loading"
            >
              <template v-slot:item.slot="{ item }">
                {{ slotText(item.slot) }}
              </template>
              <template v-slot:item.ctr="{ item }">
                {{ formatCTR(item.ctr) }}
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/libs/config.js";

export default {
  name: "AdsReport",
  data: () => ({
    loading: false,
    days: 30,
    dayOptions: [
      { text: "最近 7 天", value: 7 },
      { text: "最近 30 天", value: 30 },
      { text: "最近 90 天", value: 90 },
    ],
    report: {
      totals: { impressions: 0, clicks: 0, ctr: 0 },
      bySlot: [],
      byDate: [],
      topClicks: [],
      topCTR: [],
    },
    slotHeaders: [
      { text: "版位", value: "slot" },
      { text: "曝光", value: "impressions" },
      { text: "點擊", value: "clicks" },
      { text: "CTR", value: "ctr" },
    ],
    dateHeaders: [
      { text: "日期", value: "date" },
      { text: "曝光", value: "impressions" },
      { text: "點擊", value: "clicks" },
      { text: "CTR", value: "ctr" },
    ],
    adHeaders: [
      { text: "標題", value: "title" },
      { text: "版位", value: "slot" },
      { text: "曝光", value: "impressions" },
      { text: "點擊", value: "clicks" },
      { text: "CTR", value: "ctr" },
    ],
  }),
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      const { data } = await axios.get(`${config.API_URL}/ads/admin/reports`, {
        params: { days: this.days },
      });
      this.report = data;
      this.loading = false;
    },
    slotText(slot) {
      return slot == "top" ? "首頁主要廣告區" : "浮動廣告區";
    },
    formatCTR(value) {
      return `${((value || 0) * 100).toFixed(2)}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  padding: 0 20px;
  height: 50px;
  line-height: 50px;
  background-color: #1976d2;
  color: #fff;
}
.metric {
  background: #f5f5f5;
  border-radius: 6px;
  padding: 16px;
  text-align: center;
}
.metric-label {
  color: #666;
  font-size: 14px;
}
.metric-value {
  color: #1976d2;
  font-size: 26px;
  font-weight: 700;
}
</style>
